<template>
  <v-container class="pa-0" fluid>
    <div v-if="!showFrame && !error" class="py-5 text-center">
      <v-progress-circular
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <iframe
      ref="iframe"
      :src="url.replace('{email}', User.email)"
      :height="height"
      :style="{ opacity: showFrame }"
      :scrolling="isExternal ? 'yes' : 'no'"
      v-show="!error"
      width="100%"
      frameborder="0"
    ></iframe>
    <div class="primary--text text-center py-10" v-if="error && !auth">
      <p>Quelque chose s'est mal passé, veuillez vous déconnecter et réessayer.</p>
      <p>Si le problème persiste vous pouvez nous écrire à : thales-support.sco@geodis.com</p>
    </div>
    <div class="primary--text text-center py-10" v-if="error && auth">
      <p>Vous ne semblez pas avoir le droit nécessaire pour utiliser ce service.</p>
      <p>Veuillez demander l’accès par mail à thales-support.sco@geodis.com</p>
    </div>
  </v-container>
</template>

<script>
import Crypto from 'crypto-js';
import moment from 'moment';
import { Storage } from '@/utils';
import { mapState } from 'vuex';

const SEPARATOR = '<Sep@r¤@°R`$£>';
const WAIT = 1000;

function getArgumentsFromUrl(url) {
  let args = [];

  if (url.includes('http') || url.includes('https')) {
    args = url.split(' ');
    args.shift();
  }

  return args.reduce((acc, a) => {
    const [key, value = true] = a.split('=');
    acc[key.replace('-', '')] = value;
    return acc;
  }, {});
}

export default {
  name: 'app-home-frame',
  props: {
    menu: Array,
  },
  data() {
    return {
      error: false,
      auth: false,
      showFrame: 1,
      height: 900,
      url: '',
      domain: '',
      process: '',
      reference: '',
      progress: {
        action: false,
        message: false,
      },
    };
  },
  computed: {
    ...mapState([
      'User',
    ]),
    parentId() {
      return this.$route.params.id;
    },
    actual() {
      return (this.menu.find(p => p.menu.guid === this.parentId) || {}).menu || {};
    },
    isExternal() {
      return this.url.includes('http');
    },
  },
  methods: {
    root(actual) {
      return actual.parent ? this.root(actual.parent) : actual;
    },
    init() {
      let { url } = this.actual;
      const args = getArgumentsFromUrl(url);

      url = url.split(' ').shift();

      if (args.open) {
        window.location.href = url;
        return true;
      }

      if (args.height) {
        this.height = args.height;
      }

      if (args.navbar) {
        this.$emit('navbar', !!+args.navbar);
      }

      this.url = url;

      return url;
    },
    checkHeight() {
      window.addEventListener('message', (child) => {
        let height = child.data;
        if (typeof height !== 'number') return;
        if (height < 900) height = 900;
        this.height = height + Math.random();
      });
    },
    bpmCallback(rawData) {
      console.log('BPM callback');
      const data = rawData.split(SEPARATOR)[1];
      const res = JSON.parse(data);
      // eslint-disable-next-line
      const domain = this.url.match(/^(?:http:\/\/|www\.|https:\/\/)([^\/]+)/g)[0];
      console.log('BPM response', res);

      if (res.status && res.status === 'error') {
        this.error = true;
        this.auth = true;
      } else {
        this.url = `${domain}/portal/jsp/processDetails/assignTask.do?needToRun=true&id=${res.data.tasks[0].tkiid}`;
        this.showFrame = 1;
        this.error = false;
      }
    },
    validateBPM() {
      if (![
        'http://bpm-dev.intranet.geodis.org:9080',
        'https://bpm-uat.intranet.geodis.org',
        'https://bpm.extranet.geodis.org',
        'https://bpm.geodis.com',
      ].find(url => this.url.includes(url))) {
        console.warn('[Frame] BPM not valid');
        return false;
      }

      if (this.progress.action) {
        console.warn('[Frame] BPM already started');
        return false;
      }

      return true;
    },
    isThales(title) {
      if (title !== 'Thales') {
        console.warn('[Frame] BPM not a Thales scope');
        return false;
      }

      return true;
    },
    generateProcessString(name) {
      switch (name) {
        case 'SINGLE ORDER ENTRY TOOL': {
          return [
            'action=start',
            'bpdId=25.79af4d3b-83f5-400d-8695-afea3d336bd3',
            'snapshotId=2064.4953c64f-dd9c-423f-b637-eebe73216b64',
            'branchId=2063.1fe46259-b0c4-4f50-85e5-997cbf96125f',
            'processAppId=2066.c1abeef6-ff70-4af3-8353-6d8184d31693',
            'parts=all',
          ].join('&');
        }
        case 'TRANSPORT BY ROAD AND RACE': {
          return [
            'action=start',
            'bpdId=25.e330b7c9-5cd1-41e2-bb71-d8af6856ab7d',
            'processAppId=2066.740e1ab1-375d-4048-bbba-6a2f6ee783c8',
            'parts=header',
          ].join('&');
        }
        default: {
          return [
            'action=start',
            'bpdId=25.79af4d3b-83f5-400d-8695-afea3d336bd3',
            'processAppId=2066.c1abeef6-ff70-4af3-8353-6d8184d31693',
            'parts=header',
          ].join('&');
        }
      }
    },
    bpmAuth(process, domain, cb) {
      setTimeout(() => {
        console.log('BPM post message');
        this.$refs.iframe.contentWindow.postMessage([
          'XMLHTTPRequest',
          `${domain}/rest/bpm/wle/v1/process?${process}`,
          'POST',
          cb,
        ].join(SEPARATOR), '*');
      }, WAIT);
    },
    bpmStart() {
      if (!this.validateBPM()) {
        return false;
      }

      // eslint-disable-next-line
      const domain = this.url.match(/^(?:http:\/\/|www\.|https:\/\/)([^\/]+)/g)[0];
      const url = new URL(this.url);
      const errorTime = +url.searchParams.get('errorTime') || 15000;
      const { titleEN, titleFR } = this.root(this.actual);
      const title = titleEN || titleFR;
      const allowedOrigins = {
        'http://bpm-dev.intranet.geodis.org:9080': true,
        'https://bpm-uat.intranet.geodis.org': true,
        'https://bpm.extranet.geodis.org': true,
        'https://bpm.geodis.com': true,
      };
      const reference = (new Date()).getTime();
      const process = this.generateProcessString();

      if (!this.isThales(title)) {
        return false;
      }

      this.progress.action = true;
      this.showFrame = 0;

      console.log('[Frame] BPM start');
      console.log('[Frame] BPM process', process);
      console.log('[Frame] BPM domain', domain);

      // Use resize event from BPM to know if the site (cross domain request site)
      // has done loading, if it's the case we can send the message to BPM
      // (postMessage).
      window.addEventListener('message', (e) => {
        if (this.error) return;

        if (window._.get(e, 'data', []).length > 100) {
          this.progress.message = true;
          if (!allowedOrigins[e.origin]) return;
          console.log('[Frame] BPM message', e);
          this.bpmCallback(e.data);
        } else if (allowedOrigins[e.origin] && !this.progress.message) {
          console.log('[Frame] Trying BPM auth');
          this.bpmAuth(process, domain, reference);
        }
      });

      // Wait until error times passes to display a message, you can modify
      // this time from webportal admin, is a query string value named errorTime.
      setTimeout(() => {
        const retry = Storage.get('wp-bpm-retry');
        const expire = moment().add(5, 'min').valueOf();

        if (!this.showFrame) {
          if (!retry) {
            Storage.set('wp-bpm-retry', expire);
            window.location.reload();
          } else {
            console.error('[Frame] BPM an error occurred');
            this.error = true;

            if (moment().isAfter(expire)) {
              Storage.rm('wp-bpm-retry');
            }
          }
        }
      }, errorTime);

      return true;
    },
    mpoStart() {
      if (![
        'https://acceptance-geosco-portal.mp-objects.com',
        'https://geosco-portal.mp-objects.com',
      ].find(url => this.url.includes(url))) {
        console.log('MPO not valid.');
        return;
      }

      if (!this.url.includes('?workflow')) {
        console.log('MPO not workflow defined.');
        return;
      }

      let geodisLogin = Storage.get(this.User.email);

      if (geodisLogin) {
        geodisLogin = atob(geodisLogin);
        const date = moment().format();
        const hmac = Crypto.HmacSHA1(
          [
            geodisLogin,
            date,
            this.User.email,
          ].join('|'),
          'secret-key',
        ).toString(Crypto.enc.Base64);

        const params = [
          `userId=${window.encodeURIComponent(geodisLogin)}`,
          `dateTime=${window.encodeURIComponent(date)}`,
          `hmac=${window.encodeURIComponent(hmac)}`,
        ].join('&');

        this.url = `${this.url}&${params}`;
      } else {
        console.log('MPO not Geodis login found.');
      }
    },
  },
  mounted() {
    this.init();
    this.checkHeight();
    this.mpoStart();
    this.bpmStart();
  },
};
</script>
